<template>
  <b-container>
    <SelectCard :profile="profile" :modal_only="true" ref="select_card" :action="update_plan" />

    <b-card-group deck>
      <b-card class="text-center">
        <template v-slot:header>
          <h6 class="mb-0">Small</h6>
        </template>
        <h3>£80 / month</h3>
        <p>2 posts per month</p>

        <LoadingButton v-if="site.monthly_posts != 2" type="submit" variant='primary' :loading="is_saving.small" @click="can_update_plan(2)">Upgrade</LoadingButton>
        <b-button v-else :disabled="true">Current Plan</b-button>
      </b-card>

      <b-card class="text-center">
        <template v-slot:header>
          <h6 class="mb-0">Medium</h6>
        </template>
        <h3>£160 / month</h3>
        <p>4 posts per month</p>

        <LoadingButton v-if="site.monthly_posts != 4" type="submit" variant='primary' :loading="is_saving.medium" @click="can_update_plan(4)">Upgrade</LoadingButton>
        <b-button v-else :disabled="true">Current Plan</b-button>
      </b-card>

      <b-card class="text-center">
        <template v-slot:header>
          <h6 class="mb-0">Large</h6>
        </template>
        <h3>£320 / month</h3>
        <p>8 posts per month</p>

        <LoadingButton v-if="site.monthly_posts != 8" type="submit" variant='primary' :loading="is_saving.large" @click="can_update_plan(8)">Upgrade</LoadingButton>
        <b-button v-else :disabled="true">Current Plan</b-button>
      </b-card>


    </b-card-group>
  </b-container>
</template>

<script>

import api from '@/lib/api.js'
import SelectCard from '@/components/SelectCard.vue'

export default {
  name: 'site_content',
  props: ['profile', 'site'],
  components: {SelectCard},
  data() {
    return {
      is_saving: {
        small: false,
        medium: false,
        large: false,
      },
      monthly_posts: 0,
    }
  },
  methods: {
    can_update_plan(count) {
      this.monthly_posts = count
      if (this.profile.payment_method) {
        this.update_plan(count)
      } else {
        this.$refs.select_card.setup_billing()
        // Add a payment method, if successful then go here
      }
    },
    async update_plan(count) {
      let plan = 'small'
      if (count == 4) {
        plan = 'medium'
      }
      if (count == 8) {
        plan = 'large'
      }

      this.is_saving[plan] = true
      await api.update_site_plan(this.$route.params.site_id, 'monthly_posts', this.monthly_posts)
      this.is_saving[plan] = false

      this.$bvToast.toast(`Plan updated`, {title: 'Saved', autoHideDelay: 2000, variant: 'success'})
    }
  },
  metaInfo() {
    return {
      title: `site content auto`
    };
  },
}
</script>

<style scoped>
</style>
